// 📂 Mapeo de extensiones a MIME types
const MIME_TYPES = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  txt: "text/plain",
  csv: "text/csv",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  json: "application/json",
  mp3: "audio/mpeg",
  mp4: "video/mp4",
};

/**
 * 🔍 Obtiene el tipo MIME de un archivo a partir de su nombre o URI.
 * @param {string | object} file - Puede ser el nombre del archivo (string) o un objeto con propiedad `name` o `uri`.
 * @returns {string|null} - Devuelve el tipo MIME (por ejemplo "text/csv") o null si no se reconoce.
 */
export function getMimeTypeFromFile(file) {
  if (!file) return null;

  let fileName = typeof file === "string"
    ? file
    : file.name || file.uri || "";

  const match = fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i);
  const extension = match ? match[1].toLowerCase() : null;

  if (!extension) return null;

  return MIME_TYPES[extension] || null;
};